let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jkTol"), load("i47Xg"), load("joJy8"), load("aHE9G"), load("8m00X")]).then(() => parcelRequire('5xRci'));